import { render } from "./PackagesCreate.vue?vue&type=template&id=b8c60fb8"
import script from "./PackagesCreate.vue?vue&type=script&lang=js"
export * from "./PackagesCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__